import {useMsal} from "@azure/msal-react";
import {loginRequest} from "./authConfig";


const AzureAdLogin: React.FC<{}> = (props) => {
    const { instance } = useMsal();
    const handleLogin = () => {
        instance.loginPopup(loginRequest).catch(e => console.log(e));
    }
    return <div><h1>
        Login to VSC as a content builder</h1>
        <button onClick={() => handleLogin()}>Login</button>

    </div>;

}
export default AzureAdLogin;